module.exports = new Promise((resolve) => {
                if (typeof ymaps3 !== 'undefined') {
                    return ymaps3.ready.then(() => resolve(ymaps3));
                }

                const script = document.createElement('script');
                script.src = "https://api-maps.yandex.ru/v3/?apikey=20833a0e-d989-4ca9-8d26-287918c3eb7d&lang=ru_RU";
                script.onload = () => {
                    ymaps3.ready.then(() => resolve(ymaps3));
                };
                document.head.appendChild(script);
          });